import { FC } from "react";
import {Navigation, Logo} from "../commons";

export const Header:FC = () => {
  return (
    <header>
      <Logo />
      <Navigation />
    </header>
  );
};
